import { BaseContext } from '../../../../utils/basecontext';
import {  UIComponentHandler,  UIDataModel } from '../../uicomponent';
import { UIComponentView } from '../../uicomponentview';
import { PlayerComponent } from '../playercomponent';
import { PlayerWithProgressView } from './playerwithprogressview';


export class PlayerWithProgressComponent extends PlayerComponent
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new PlayerWithProgressView(applicationContext, uiComponentHandler);

    }

    playStart()
    {
       this.props.isAutoPlayRequired !==undefined && this.props.isAutoPlayRequired && this.onPlayClicked();
    }

    onPlayComplete(): void
    {
        super.onPlayComplete();

        (this.getView() as PlayerWithProgressView).updateProgress(0);        
    }

    updateProgress(currentPercentage: number)
    {   
        (this.getView() as PlayerWithProgressView).updateProgress(currentPercentage);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/player/playerwithprogress/playerwithprogress.tsx